/* eslint-disable */

import { useEffect } from 'react';
import GraphContainer from '../GraphContainer/GraphContainer.component';
import './EmbedContainer.style.css';

export interface EmbedContainerProps {
	isFilterContainerHidden: boolean;
	graphData: any;
	rawFrequencyData: any;
	extendedFrequencyData: any;
	galaxyData: any;
	colors: string[];
	isError: boolean;
	setIsError: any;
	isPending: boolean;
}

const EmbedContainer: React.FC<EmbedContainerProps> = ({
	graphData,
	rawFrequencyData,
	galaxyData,
	colors,
	extendedFrequencyData,
	isError,
	setIsError,
	isPending,
}) => {
	return (
		<div className="embed-container">
			<GraphContainer
				isError={isError}
				setIsError={setIsError}
				isPending={isPending}
				graphData={graphData}
				rawFrequencyData={rawFrequencyData}
				extendedFrequencyData={extendedFrequencyData}
				galaxyData={galaxyData}
				colors={colors}
			/>
		</div>
	);
};

export default EmbedContainer;
